import { useTranslation } from "react-i18next";
import { useRecordContext } from "react-admin";
import QuickViewCard from "../../../components/Common/QuickViewCard";
import InfoRow from "../../../components/Common/InfoRow";
import { formatEuro } from "../../../utils/paymentFormat";
import { StatementStatusLabel } from "./StatementStatusLabel";
import { ProjectField } from "../ProjectField";
import { Box } from "@mui/material";
import { monthLabel } from "./InfoStatementTab";

function RecentActivity() {
  const { t }: { t: any } = useTranslation();
  const record = useRecordContext();
  if (!record) return null;

  return (
    <QuickViewCard>
      <InfoRow label={t("Status")}>
        <StatementStatusLabel />
      </InfoRow>
      <InfoRow label={t("Entity")}>
        <Box component="span" sx={{ "& .MuiTypography-root": { fontWeight: 700 } }}>
          <ProjectField />
        </Box>
      </InfoRow>
      <InfoRow label={t("Month")}>{monthLabel(record.month)}</InfoRow>
      <InfoRow label={t("Total fee")}>{formatEuro(record.totalFeeEur) || "—"}</InfoRow>
      <InfoRow label={t("Line items")}>{(record.lineItems || []).length}</InfoRow>
    </QuickViewCard>
  );
}

export default RecentActivity;
